import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagMY = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M23.913 24.998H50c0-2.256-.301-4.442-.861-6.522H23.913v6.522ZM23.913 11.956H46.33a25.13 25.13 0 0 0-5.768-6.522h-16.65v6.522ZM24.999 49.998a24.893 24.893 0 0 0 15.562-5.434H9.437a24.893 24.893 0 0 0 15.562 5.434ZM3.669 38.043h42.66a24.851 24.851 0 0 0 2.809-6.522H.86a24.85 24.85 0 0 0 2.809 6.522Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M25 25V0C11.193 0 0 11.193 0 25h25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M16.625 21.4a6.182 6.182 0 1 1 2.94-11.622 7.609 7.609 0 1 0 0 10.878 6.156 6.156 0 0 1-2.94.743Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m18.368 10.87 1.098 2.295 2.478-.572-1.11 2.289 1.994 1.58-2.482.56.007 2.544-1.985-1.592-1.985 1.592.007-2.544-2.482-.56 1.994-1.58-1.11-2.29 2.479.573 1.097-2.295Z"
}));
FlagMY.displayName = 'FlagMY';
export default withFlagWrapper(FlagMY);
//# sourceMappingURL=index.js.map